<template>

    <transition
            name="panel-fade"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut">

        <div class="panel-wrapper">

            <!-- HEADER -->
            <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
                <span class="label" v-html="title"></span>
            </div>
            <!-- END HEADER -->

            <!-- CONTENT -->
            <div class="panel-content">

                <!-- BODY -->
                <div class="body">
                    <div class="inner" v-html="content"></div>
                </div>
                <!-- END BODY -->

            </div>
            <!-- END CONTENT -->

        </div>

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'mobile-content-terms',

        props: ['panel'],

        components: {},

        data() {
            return {
                title: 'Terms and Conditions'
            }
        },

        computed: {

            content() {
                return this.$dataStore.getters.getTermsData;
            }

        },

        created() {
            //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
        },

        mounted() {
            //console.info('%csidebar-content-privacy::mounted', 'color:green;');

            vm = this;
        },

        methods: {
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }
        },

        events: {

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .panel-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;

        & .header {
            background-color: var(--color-primary);
            color: $white-100;
            line-height: 1;
            height: 50px;
            padding: 17px 16px 16px;
            overflow: hidden;
            display: flex;
            justify-content: center;

            & .icon {
                flex: 0 0 auto;

                & label {
                    width: 100%;
                    height: 100%;
                    margin: 0 0 0 0;

                    @media (hover:hover) {
                        &:hover {
                            cursor: pointer;

                            & .fa {
                                opacity: 0.8;
                                transition: all 0.3s $easeInOutQuad;
                            }
                        }
                    }

                    & .fa {
                        opacity: 1;
                        transition: all 0.3s $easeInOutQuad;
                    }
                }
            }

            & .label {
                font-family: $font-univers-cond;
                font-size: 1rem;
                text-align: center;
                text-transform: uppercase;
                letter-spacing: 0.7px;
                white-space: nowrap;
                margin: 0 0 0 -17px;
                padding: 0 0 0 0;
                flex: 1 0 auto;
            }
        }
    }

    .panel-content {

        & .body {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: left;
            padding: 1.875rem;

            &.no-pad {
                padding: 0;
            }

            &.no-pad-lr {
                padding: 30px 0;
            }

            &.no-pad-tb {
                padding: 0 30px;
            }

            & h3 {
                font-family: $font-univers-bold;
                font-size: 1rem;
                font-weight: normal;
                line-height: 1;
                text-transform: none;
                margin: 0 0 12px 0;
            }

            & p {
                font-size: 0.875rem;
                line-height: 1.438;
            }

            & ul {
                padding-left: 18px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

        }
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .panel-content {

        & .body {
            font-family: $font-univers-std;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.438;
            letter-spacing: 0;
            text-align: left;
            padding: 1.875rem;

            &.no-pad {
                padding: 0;
            }

            &.no-pad-lr {
                padding: 30px 0;
            }

            &.no-pad-tb {
                padding: 0 30px;
            }

            & h3 {
                font-family: $font-univers-bold;
                font-size: 1rem;
                font-weight: normal;
                line-height: 1;
                text-transform: none;
                margin: 0 0 12px 0;
            }

            & p {
                font-size: 0.875rem;
                line-height: 1.438;
            }

            & ul {
                padding-left: 18px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

        }
    }

</style>


// WEBPACK FOOTER //
// MobileContentTerms.vue?20b3ce79